import { SHOW_POPUP, HIDE_POPUP } from './actionTypes';

const showPopup = ({ children }) => ({
  type: SHOW_POPUP,
  payload: {
    children,
  },
});

export const hidePopup = () => ({
  type: HIDE_POPUP,
});

export const showPopupContent = ({ children }) => async dispatch => {
  dispatch(showPopup({ children }));
};

export const hidePopupContent = () => async dispatch => {
  dispatch(hidePopup());
};
